<template>
  <div class="list-topics">
    <Tree
      :value="treeData"
      @input="handleItemsChange"
      :indent="30"
      :eachDroppable="eachDroppable"
      triggerClass="icon-drag"
      :draggable="$auth.policies['update-event']"
      @drop="store => $emit('onUpdateIndex', store)"
    >
      <template slot-scope="{ node }">
        <v-expansion-panels flat multiple :value="[0]">
          <v-expansion-panel class="expansion-topic">
            <div class="icon-drag cursor-pointer" v-if="$auth.policies['update-event']">
              <v-icon>mdi-drag</v-icon>
            </div>
            <v-expansion-panel-header disable-icon-rotate>
              <span class="ml-3">{{ node.title }}</span>
              <template v-slot:actions>
                <div class="d-flex justify-end" v-if="$auth.policies['update-event']">
                  <v-btn icon @click.stop="$emit('onEdit', node)" class="action-hover">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="$emit('onRemove', node)">
                        <v-list-item-content>
                          <v-list-item-title>Xóa</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex">
                <div class="slot-subtitle text-body-2">Thời gian</div>
                <div class="slot-content text-body-2" style="white-space:pre;">{{ node.date }}</div>
              </div>
              <div class="d-flex mt-2">
                <div class="slot-subtitle text-body-2">Địa điểm</div>
                <div class="slot-content text-body-2">{{ node.location }}</div>
              </div>
              <div class="d-flex mt-2">
                <div class="slot-subtitle text-body-2">Số lớp</div>
                <div class="slot-content text-body-2">{{ node.quantity }}</div>
              </div>
              <div class="d-flex mt-2">
                <div class="slot-subtitle text-body-2">Giới hạn</div>
                <div class="slot-content text-body-2">
                  {{ node.attendLimit }} <span class="grey--text">({{ node.countStudents }} đã đăng ký)</span>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </Tree>
  </div>
</template>
<script>
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Draggable } from 'he-tree-vue'

const MAX_TIER = 1
export default {
  components: {
    Tree: Tree.mixPlugins([Draggable])
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      treeData: []
    }
  },
  methods: {
    eachDroppable(path) {
      return path.length <= MAX_TIER - 1
    },
    async handleItemsChange(treeData) {
      await this.$utils.delay(500)
      this.treeData = [...treeData]
    },
    getData() {
      return this.treeData
    }
  },
  watch: {
    items: {
      handler(val) {
        this.treeData = val
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .tree-node {
    border: 0;
    padding: 0;
  }
}

.icon-drag {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  transform: translate(-15%, 15%);
  .v-icon {
    padding: 12px 0 0 12px;
  }
}
::v-deep .expansion-topic {
  > .v-expansion-panel-header {
    &--active {
      min-height: 48px;
    }
  }
  &.v-expansion-panel {
    border: 1px solid rgb(227, 227, 227);
  }
}
.slot-subtitle {
  width: 100px;
  color: grey;
}
.slot-content {
  width: calc(100% - 100px);
}
</style>
